import React, { useContext, useRef } from "react";
import { findDOMNode } from "react-dom";
import classNames from 'classnames';
import { Card, Affix, Grid } from '@alifd/next';
import CheckCell from "../check-cell";
import { StaticContext, LayoutContext, SelectionContext } from "../contexts";
import "./index.scss";
var Row = Grid.Row,
  Col = Grid.Col;
function HeaderDefaultInner(props) {
  var _props$columns = props.columns,
    columns = _props$columns === void 0 ? [] : _props$columns;
  return /*#__PURE__*/React.createElement(Row, null, columns.map(function (col, index) {
    var title = col.title,
      span = col.span,
      fixedSpan = col.fixedSpan,
      align = col.align;
    return /*#__PURE__*/React.createElement(Col, {
      key: index,
      span: span,
      fixedSpan: fixedSpan,
      style: align ? {
        textAlign: align
      } : undefined
    }, title);
  }));
}
function Header(props) {
  var className = props.className,
    children = props.children;
  var _useContext = useContext(StaticContext),
    sticky = _useContext.sticky,
    columns = _useContext.columns;
  var _useContext2 = useContext(LayoutContext),
    toolbarHeight = _useContext2.toolbarHeight,
    headerHeight = _useContext2.headerHeight,
    setHeaderHeight = _useContext2.setHeaderHeight;
  var elementRef = useRef(null);
  var affixed = !!toolbarHeight;
  var grouped = !!toolbarHeight && !!headerHeight;
  var handleAffix = function handleAffix(willAffix) {
    if (willAffix) {
      var element = findDOMNode(elementRef.current);
      setHeaderHeight((element === null || element === void 0 ? void 0 : element.clientHeight) || 0);
    } else {
      setHeaderHeight(0);
    }
  };
  var result = /*#__PURE__*/React.createElement(Card, {
    ref: elementRef,
    className: classNames('list-header', className, {
      affixed: affixed,
      grouped: grouped
    }),
    free: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-header-head"
  }, /*#__PURE__*/React.createElement(SelectionContext.Consumer, null, function (selection) {
    var enabled = selection.enabled;
    return enabled && /*#__PURE__*/React.createElement(CheckCell, {
      className: "aplus-auto-exp",
      "data-spm": "d_list_head_check_cell",
      invisible: true
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "list-header-wrapper"
  }, children || /*#__PURE__*/React.createElement(HeaderDefaultInner, {
    columns: columns
  })));
  if (sticky) {
    result = /*#__PURE__*/React.createElement(Affix, {
      offsetTop: toolbarHeight,
      onAffix: handleAffix
    }, result);
  }
  return result;
}
export default Header;